<template>
  <div class="FailPayment">
    <div>
      <p><img src="./image/fail.png" alt="image" /></p>
      <p>支付失败</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FailPayment',
};
</script>

<style scoped lang="less">
.FailPayment {
  text-align: center;
  font-size: 24px;
  /*flex 布局*/
  display: flex;
  /*实现垂直居中*/
  align-items: center;
  /*实现水平居中*/
  justify-content: center;
  width: 200px;
  height: 100vh;
  margin: 0 auto;
}
</style>
